import { DistanceTypes } from '../stores/user';

export function joinText(textArray, separator = '') {
  if (!textArray || !textArray.length) return '';
  return textArray.filter((text) => text?.length > 0).join(separator);
}

export function findImageSource(url) {
  const map = new Map([
    ['wikipedia', 'Wikipedia'],
    ['facebook', 'Facebook'],
  ]);
  for (let key of map.keys()) {
    if (url.includes(key)) {
      return map.get(key);
    }
  }
  return 'official_website';
}

export function getDistanceString(distance, unit) {
  const distanceConverted =
    unit === DistanceTypes.imperial ? distance / 1600 : distance / 1000;

  //remove digits after the dezimal point if > 5
  if (distanceConverted >= 5)
    return `${Number.parseInt(distanceConverted)} ${unit}`;

  return `${
    Math.round((distanceConverted + Number.EPSILON) * 100) / 100
  } ${unit}`;
}
